import React, { useEffect, useRef, useState } from 'react';
import { ForgeDialog, ForgeButton } from '@tylertech/forge-react';
import { FeatureFlags } from 'common/feature_flags';

interface ProcessDiscoveryEmbedModalProps {
  showModal?: boolean;
  url: string;
  onDismiss: () => void;
}

const ProcessDiscoveryEmbedModal = ({ url, onDismiss, showModal }: ProcessDiscoveryEmbedModalProps) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [loadCount, setLoadCount] = useState(0);

  useEffect(() => {
    const iframe = iframeRef.current;
    const handleLoad = () => {
      setLoadCount((prev) => {
        const newCount = prev + 1;

        // If iframe loads more than once, assume a redirect
        if (newCount > 1) {
          console.warn('Possible redirect detected. Opening in new tab...');
          onDismiss(); // Close the modal
          window.open(url, '_blank');
        }

        return newCount;
      });
    };

    if (FeatureFlags.valueOrDefault('enable_tir_actions_auth_workaround', false) && iframe) {
      iframe.addEventListener('load', handleLoad);
    }

    return () => {
      if (FeatureFlags.valueOrDefault('enable_tir_actions_auth_workaround', false) && iframe) {
        iframe.removeEventListener('load', handleLoad);
      }
    };
  }, [url, loadCount, onDismiss]);

  return (
    <ForgeDialog open={showModal} on-forge-dialog-close={onDismiss}>
      <div className="process-discovery-modal-body" data-testid="process-discovery-modal-body">
        <iframe ref={iframeRef} src={url} style={{ width: '100%', height: '100%' }} />
        {FeatureFlags.valueOrDefault('enable_eerp_modal_close_button_workaround', false) ? (
          <ForgeButton className="hacked-close-button" variant="raised" onClick={onDismiss}>
            Close
          </ForgeButton>
        ) : null}
      </div>
    </ForgeDialog>
  );
};

export default ProcessDiscoveryEmbedModal;
